module.exports = __webpack_public_path__ + "img/2-23.7e6ccd94.jpg";